module.exports = __webpack_public_path__ + "static/img/5.5e00afe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/zh/5.png
// module id = Ko2v
// module chunks = 0